<div class="error-list alert alert-danger" *ngIf="system_errors.length > 0 || errorList.length > 0 ">
    <h4>Found errors while saving.</h4>
    <ul>
        <li *ngFor="let item of errorList">{{item}}</li>
        <li *ngFor="let item of system_errors">{{item}}</li>
    </ul>
</div>
